import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import { doc, updateDoc, getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import 'bootstrap/dist/css/bootstrap.min.css';

const auth = getAuth();
const db = getFirestore();

const StripeCheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate(); // useNavigate hook for programmatic navigation
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (!stripe || !elements) {
      setIsLoading(false);
      return;
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: 'https://zielstudienkolleg.de/shop', // Redirect URL for cancelled or unsuccessful payments
      },
      redirect: 'if_required'
    });

    if (error) {
      console.error("Error during payment confirmation: ", error);
      alert("Произошла ошибка при платеже!");
      setIsLoading(false);
      navigate('/shop'); // Redirect to /shop if there is an error
      return;
    }

    if (paymentIntent.status === 'succeeded') {
      try {
        const userId = auth.currentUser?.uid;
        if (!userId) {
          throw new Error("User ID is missing.");
        }

        const promises = props.items.map(async (item) => {
          const examCollection = item.Exam;
          const topic = item.Topic;

          if (!examCollection || !topic) {
            throw new Error("Exam collection or Topic is missing.");
          }

          const receiptDoc = doc(db, 'Users', userId, 'Purchases', examCollection);
          const expiryDate = new Date();
          expiryDate.setFullYear(expiryDate.getFullYear() + 1);

          await updateDoc(receiptDoc, {
            [topic]: expiryDate
          });
        });

        await Promise.all(promises);

        setIsLoading(false);
        navigate('/comp'); // Redirect after successful update
      } catch (updateError) {
        console.error("Error updating document: ", updateError);
        alert("Произошла ошибка при обновлении документа!");
        setIsLoading(false);
        navigate('/shop'); // Redirect to /shop if there is an error during the document update
      }
    } else {
      alert("Произошла ошибка при платеже!");
      setIsLoading(false);
      navigate('/shop'); // Redirect to /shop if the payment is not successful
    }
  };

  return (
    <div className="payment-form">
      {isLoading && (
        <p className="payment-form__status" role="status">
          Пожалуйста, подождите. Платёж обрабатывается.
        </p>
      )}
      <form id="payment-form-element" onSubmit={handleSubmit}>
        <PaymentElement />
        <button
          type="submit"
          className="btn btn-main-md btn-primary payment-form__submit"
          disabled={!stripe || isLoading}
        >
          {isLoading ? 'Обрабатываем…' : 'Оплатить'}
        </button>
      </form>
    </div>
);

};

export default StripeCheckoutForm;
















